import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { HideLastNamePipe } from '@shared/pipes/hide-last-name.pipe';
import { Utils } from '@shared/utils/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, HideLastNamePipe, NgClass],
  selector: 'aux-first-name-show',
  styles: [],
  templateUrl: './first-name-show.component.html',
})
export class FirstNameShowComponent {
  _showHyphenIfEmpty = false;
  _text = '';
  @Input() className?: string = '';
  name = '';
  tooltip = '';

  @Input() set showHyphenIfEmpty(bool: boolean) {
    this._showHyphenIfEmpty = bool;
    this.updateName();
    this.updateTooltip();
  }

  get showHyphenIfEmpty() {
    return this._showHyphenIfEmpty;
  }

  @Input() set text(text: string) {
    this._text = text;
    this.updateName();
    this.updateTooltip();
  }

  get text() {
    return this._text;
  }

  updateName() {
    this.name = this.text || (this.showHyphenIfEmpty ? Utils.zeroHyphen : '');
  }

  updateTooltip() {
    let name = this.name;

    if (name === 'Auxilius Expert' || name === Utils.zeroHyphen) {
      name = '';
    }

    this.tooltip = name;
  }
}
